module.exports = __webpack_public_path__ + "img/race.b94f139d.png";